import { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import CarouselImage from './CarouselItem';
import '../styles/carousel.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import { useSchedule } from '../data/useLocations';

const SLIDE_DURATION = 7000;

/**
 * Zdjęcie widoczne zanim dojadą dane z Firestore.
 * Plik leży w public/, więc ścieżka musi iść przez JS - css-loader
 * próbowałby rozwiązać ją względem src/styles i wywala build.
 * Kadr musi być ten sam co pierwszy slajd, inaczej widać podmianę.
 */
const PLACEHOLDER_STYLE = {
  backgroundImage:
    'linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.5)), url(/hero-placeholder.webp)',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
};

const CTA_STYLE = {
  backgroundColor: '#d0142d',
  padding: '6px 25px',
  borderRadius: '20px',
  color: 'rgb(250,250,250)',
  fontWeight: 'bold',
  cursor: 'pointer',
  fontSize: '13px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  textDecoration: 'none',
};

function PhotoCarousel() {
  const { data, loading } = useSchedule();
  const slides = data?.heroSlides || [];

  const [index, setIndex] = useState(0);
  const slideCount = slides.length;

  useEffect(() => {
    if (index >= slideCount) setIndex(0);
  }, [slideCount, index]);

  useEffect(() => {
    if (slideCount <= 1) return;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slideCount);
    }, SLIDE_DURATION);
    return () => clearInterval(timer);
  }, [slideCount]);

  // Miejsce na karuzelę rezerwujemy zanim dojadą dane - inaczej strona
  // układa się bez niej i po wczytaniu przeskakuje o całą jej wysokość.
  if (slideCount === 0) {
    return loading ? (
      <div className="carousel-wrapper" aria-hidden="true" style={PLACEHOLDER_STYLE} />
    ) : null;
  }

  return (
    <div className="carousel-wrapper">
      <Carousel
        activeIndex={index}
        onSelect={(i) => setIndex(i)}
        indicators={false}
        controls={false}
      >
        {slides.map((s) => (
          <Carousel.Item key={s.id}>
            <CarouselImage
              title={s.title}
              image={`url(${s.imageUrl})`}
              text={s.text}
              comment={s.comment}
            />
            <Carousel.Caption
              style={{
                marginBottom: '50px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                {s.ctaPath ? (
                  <Link to={s.ctaPath} style={CTA_STYLE}>
                    <img src="/pin.png" style={{ width: '28px' }} alt="" />
                    {s.ctaLabel}
                  </Link>
                ) : s.ctaHref ? (
                  <a
                    href={s.ctaHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={CTA_STYLE}
                  >
                    <img src="/pin.png" style={{ width: '28px' }} alt="" />
                    {s.ctaLabel}
                  </a>
                ) : null}
              </div>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>

      {slideCount > 1 ? (
        <div className="custom-indicators">
          {slides.map((s, i) => (
            <div
              key={s.id}
              className={`circle ${i === index ? 'animating' : ''}`}
              onClick={() => setIndex(i)}
              style={{ cursor: 'pointer' }}
              role="button"
              tabIndex={0}
              aria-label={`Slajd ${i + 1}: ${s.title}`}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setIndex(i);
                }
              }}
            >
              <span className="number">{i + 1}</span>
              {i === index && (
                <svg
                  key={`svg-${i}-${index}`}
                  className="progress-svg"
                  viewBox="0 0 36 36"
                >
                  <circle className="progress-back" cx="18" cy="18" r="16" />
                  <circle
                    className="progress-ring"
                    cx="18"
                    cy="18"
                    r="16"
                    style={{ animationDuration: `${SLIDE_DURATION}ms` }}
                  />
                </svg>
              )}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default PhotoCarousel;